export enum BagsOfDifferentMaterialsLabels {
  type = "type",
  dimensions = "dimensions",
  color = "color",
  print = "print",
}
